export const hourlyCalendar = {
  title: "Kalendarz godzinowy",
  navSubtitle: "Rezerwacja godzinowa w hotelu",
  hotel: "Hotel",
  rooms: "Pokoje",
  roomsAbbr: "pokoi",
  noDisp: "N/D",
  footer: {
    free: "{n} wolnych",
    occupied: "{n} zajętych",
    cleaning: "{n} w trakcie sprzątania",
    timezone: "Strefa czasowa: {tz}",
  },
  today: "Dzisiaj",
  prevDay: "Poprzedni dzień",
  nextDay: "Następny dzień",
  newStay: "Nowy pobyt",
  settingsBtn: "Ustawienia rezerwacji godzinowej",
  retry: "Spróbuj ponownie",
  dragHint: "Przeciągnij wzdłuż pokoju, aby utworzyć pobyt",
  groupFree: "Wolne: {free} z {total}",
  zoom: { label: "Powiększenie", compact: "Kompaktowy", normal: "Normalny", wide: "Szeroki" },
  duration: { min: "{n} min", h: "{n} h", hmin: "{h} h {m} min" },
  kpi: {
    free: "Wolne teraz",
    occupied: "Zajęte",
    cleaning: "W trakcie sprzątania",
    arrivals: "Przyjazd w ciągu 1 h",
    overdueAlert: "1 pokój przekroczył godzinę check-out | {n} pokoje przekroczyły godzinę check-out | {n} pokoi przekroczyło godzinę check-out",
  },
  state: {
    free: "Wolny",
    freeNext: "Wolny · następny {time}",
    soon: "Przyjazd o {time}",
    occupied: "Zajęty",
    occupiedLeft: "Zajęty · pozostało {time}",
    overdue: "Przekroczono o {time}",
    due: "Oczekuje na check-in",
    cleaning: "Sprzątanie · {time}",
    closed: "Zamknięty",
    maintenance: "Wyłączony z użytku",
  },
  status: {
    booked: "Zarezerwowany",
    in_house: "W trakcie",
    checked_out: "Zakończony",
    cancelled: "Anulowany",
    no_show: "Niestawienie się",
  },
  block: {
    noName: "Bez nazwy",
    blocked: "Zablokowany",
    night: "Noc",
    closed: "Zamknięty",
    maintenance: "Wyłączony z użytku",
    left: "pozostało {time}",
  },
  legend: {
    booked: "Zarezerwowany",
    inHouse: "W trakcie",
    overdue: "Przekroczony",
    cleaning: "Sprzątanie",
    night: "Rezerwacja nocna",
    closed: "Zamknięty",
  },
  rangeMenu: {
    create: "Utwórz pobyt",
    createSub: "W zaznaczonym przedziale czasu",
    block: "Zablokuj ten przedział",
    blockSub: "Pokój nie będzie sprzedawany w tym przedziale",
    closeDay: "Zamknij pokój na cały dzień",
    closeDaySub: "Ten pokój nie jest sprzedawany tego dnia",
  },
  blockMenu: {
    editReason: "Zmień powód",
    editReasonSub: "Jest widoczny w kalendarzu",
    remove: "Usuń blokadę",
    removeSub: "Pokój wraca do sprzedaży",
  },
  blockModal: {
    titleRange: "Zablokuj ten przedział",
    titleDay: "Zamknij pokój",
    titleEdit: "Powód blokady",
    msgRange: "{room}: brak sprzedaży w godzinach {range}.",
    msgDay: "{room}: brak sprzedaży w dniu {date}.",
    msgDayRest: "{room}: brak sprzedaży do końca dnia (od {time}).",
    msgEdit: "{room}",
    reasonLabel: "Powód",
    reasonHint: "(widoczny w kalendarzu)",
    placeholder: "Konserwacja, użytek własny…",
    cancel: "Anuluj",
    block: "Zablokuj",
    save: "Zapisz",
    presetMaintenance: "Konserwacja",
    presetOwner: "Użytek właściciela",
    presetRepair: "Remont",
    presetDeepClean: "Sprzątanie gruntowne",
    presetClosed: "Zamknięty",
  },
  drawer: {
    close: "Zamknij",
    closeBtn: "Zamknij",
    newTitle: "Nowy pobyt",
    newPill: "Nowy",
    when: "Kiedy",
    room: "Pokój",
    start: "Check-in",
    end: "Check-out",
    nextDay: "następnego dnia",
    duration: "Czas trwania",
    other: "Inne",
    free: "Pokój wolny o tej porze",
    freeWithCleaning: "Wolny · {n} min jest rezerwowane na sprzątanie po wyjściu",
    freeWillClose: "Wolny · potem pozostaje zamknięty do {hour}",
    busy: "Zajęty od {from} do {to}",
    busyClosed: "Zamknięty od {from} do {to}",
    busyMaintenance: "Pokój wyłączony z użytku",
    guest: "Gość",
    guestName: "Imię i nazwisko",
    phone: "Telefon",
    optional: "Opcjonalne",
    guests: "Osoby",
    charge: "Płatność",
    price: "Cena",
    method: "Metoda płatności",
    methods: { cash: "Gotówka", card: "Karta", transfer: "Przelew", other: "Inna" },
    paid: "Opłacone",
    paidHint: "Masz już pieniądze za ten pobyt.",
    notes: "Uwagi",
    notesPh: "Numer rejestracyjny, prośby, wszystko, co przydatne",
    guestTitle: "Rejestracja gościa",
    sendCheckin: "Wyślij link do check-in",
    sendCheckinHint: "Zostanie wysłany po zapisaniu, na telefon gościa.",
    sendCheckinNoPhone: "Aby wysłać check-in, należy dodać telefon gościa.",
    doCheckin: "Wykonaj check-in",
    edit: "Edytuj",
    client: "Gość",
    paidYes: "Opłacone",
    paidNo: "Nieopłacone",
    markPaid: "Oznacz jako opłacone",
    doCheckinHint: "Otwórz na telefonie gościa lub udostępnij link: imię, nazwisko i dokument, ze skanem, jeśli gość zechce.",
    copyLink: "Kopiuj link",
    copied: "Link skopiowany",
    checkinDone: "Check-in wykonany · zarejestrowano {n} gościa | Check-in wykonany · zarejestrowano {n} gości | Check-in wykonany · zarejestrowano {n} gości",
    checkinErrors: {
      no_reservation: "Aby móc poprosić o check-in, należy włączyć w ustawieniach opcję „Rejestruj pobyty jako rezerwacje”.",
      no_phone: "Aby wysłać, należy dodać telefon gościa.",
      send_failed: "Nie udało się wysłać. Można skopiować link i udostępnić go samodzielnie.",
      not_requested: "Nie udało się wysłać. Można skopiować link i udostępnić go samodzielnie.",
    },
    checkinSent: "Check-in wysłany",
    sendCheckinFailed: "Nie udało się wysłać check-in. Proszę sprawdzić telefon gościa.",
    save: "Zapisz",
    saveAndIn: "Zapisz i zamelduj",
    saveChanges: "Zapisz zmiany",
    checkIn: "Zamelduj",
    checkOut: "Wymelduj",
    extend30: "30 min",
    extend60: "1 h",
    extendOther: "Inne",
    extendHow: "Przedłuż",
    extendApply: "Przedłuż",
    cancelBtn: "Anuluj",
    checkOutNotYet: "Check-out będzie możliwy po rozpoczęciu pobytu",
    confirmEarlyOutTitle: "Pobyt jeszcze się nie rozpoczął",
    confirmEarlyOut: "Ten pobyt zaczyna się później. Wymeldowanie teraz zamknie go i zwolni pokój. Jeśli gość w ogóle nie przyjechał, lepiej użyć opcji „Niestawienie się”.",
    noShow: "Niestawienie się",
    cancelStay: "Anuluj pobyt",
    keep: "Wróć",
    confirmCancel: "Pobyt zostanie anulowany, a pokój będzie wolny o tej porze. Tej operacji nie można cofnąć.",
    confirmNoShow: "Termin wraca do sprzedaży. Zostanie odnotowane, że gość nie przyjechał.",
    confirmNoShowInHouse: "Gość został zameldowany, ale nigdy nie wszedł do pokoju: check-in zostanie cofnięty, a termin znów będzie wolny.",
    confirmCancelInHouse: "Gość został zameldowany: check-in zostanie cofnięty, pobyt anulowany, a pokój zwolniony. Tej operacji nie można cofnąć.",
    confirmNoShowTitle: "Gość się nie stawił?",
    confirmCancelTitle: "Anulować ten pobyt?",
    remaining: "pozostało {time}",
    overdue: "{time} po godzinie check-out",
    startsIn: "Rozpoczyna się za {time}",
    waiting: "Godzina już nadeszła: oczekuje na check-in",
    closedInfo: "Pobyt zamknięty: można zmienić tylko płatność i uwagi.",
    night: {
      title: "Rezerwacja nocna",
      dates: "Od {from} do {to}",
      code: "Kod",
      channel: "Kanał",
      hint: "Rezerwacjami nocnymi zarządza się w kalendarzu hotelu. Są tu pokazywane, aby żaden pobyt godzinowy na nie nie nachodził.",
      open: "Przejdź do kalendarza hotelu",
    },
  },
  settings: {
    title: "Rezerwacja godzinowa",
    enable: "Wynajem na godziny",
    subtitle: "Jak ten hotel sprzedaje na godziny",
    offTitle: "W razie wyłączenia",
    offBody: "Kalendarz godzinowy przestanie być dostępny, a hotel będzie działał jak wcześniej. Nic nie zostanie usunięte.",
    offBodyStays: "Zaplanowanych pobytów godzinowych: {n}. Nie zostaną usunięte, ale nie będą widoczne do czasu ponownego włączenia.",
    enabledOn: "Włączone: kalendarz godzinowy jest w użyciu",
    enabledOff: "Wyłączone",
    requirements: "Wymagania",
    req: {
      rooms: "Utworzone pokoje ({n})",
      channels: "Brak podłączonych kanałów sprzedaży",
      ical: "Brak zsynchronizowanych kalendarzy iCal",
      web: "Rezerwacja online wyłączona",
      nights: "Nadchodzące rezerwacje nocne: {n}. Pojawią się w kalendarzu i zablokują swoje pokoje",
    },
    reqWhy: "Kanały, iCal i strona internetowa sprzedają noce i nie znają godzin: przy którymkolwiek z nich włączonym ten sam pokój mógłby zostać sprzedany dwa razy.",
    cleaning: "Sprzątanie między pobytami",
    cleaningHint: "Rezerwowane automatycznie po każdym check-out.",
    pending: "Oczekuje na sprzątanie",
    pendingHint: "Gdy gość wychodzi, pokój przez ten czas jest oznaczony „do sprzątania” w Sprzątaniu i w aplikacji. NIE blokuje sprzedaży: jeśli ktoś wejdzie wcześniej, sprzątasz wtedy.",
    none: "brak",
    minutes: "min",
    hours: "h",
    closeTitle: "Zamknij do godziny otwarcia",
    closeHint: "Na wypadek, gdy nie sprzątasz od razu: pokój pozostaje zamknięty i nikt nie może go sprzedać, dopóki go nie otworzysz.",
    closeAfterStay: "Po zakończeniu pobytu zostaw pokój zamknięty",
    closeAfterStayHint: "Zamyka się sam do godziny otwarcia następnego dnia. Jeśli posprzątasz wcześniej, naciśnij „Jest czysty” i wraca do sprzedaży.",
    afterTitle: "Po każdym pobycie",
    afterHint: "Jak długo pokój nie jest sprzedawany po wyjściu klienta.",
    untilOpening: "Do otwarcia",
    reopenHour: "Godzina otwarcia sprzedaży",
    reopenNote: "Brudne pokoje wracają do sprzedaży o {hour}.",
    markClean: "Jest czysty",
    markCleanHint: "Otwiera pokój teraz, bez czekania na godzinę otwarcia.",
    closeThisStay: "Zostaw pokój zamknięty po zakończeniu",
    closeThisStayHint: "Nie będzie można go sprzedać do {hour}. Godzinę zmienisz w ustawieniach.",
    dayStart: "Początek doby kalendarzowej",
    dayRange: "od {from} do {from} następnego dnia",
    dayStartHint: "Warto wybrać najspokojniejszą godzinę, aby noc była widoczna w całości.",
    quickHours: "Szybkie czasy trwania",
    quickHoursHint: "Pokazywane jako skróty przy tworzeniu pobytu (maksymalnie 6).",
    guestTitle: "Rejestracja gościa",
    asReservation: "Rejestruj pobyty jako rezerwacje",
    asReservationHint: "Każdy pobyt tworzy swoją rezerwację: dzięki temu pieniądze pojawiają się w raportach i możesz poprosić o zameldowanie oraz zgłoszenie gości. Po wyłączeniu sprzedaż godzinowa nie wlicza się do przychodów.",
    checkinDefault: "Domyślnie proś o check-in",
    checkinDefaultHint: "Przełącznik w formularzu pobytu będzie od razu włączony.",
    guestHint: "Te rezerwacje nie otrzymują wiadomości przeznaczonych dla pobytów nocnych (powitanie, przyjazd, check-out ani opinia): link do check-in jest wysyłany na żądanie.",
    save: "Zapisz ustawienia",
    saved: "Ustawienia zostały zapisane",
  },
  empty: {
    eyebrow: "Rezerwacja godzinowa",
    title: "Wynajem pokoi na godziny",
    body: "Kalendarz stworzony dla moteli i hoteli na krótkie pobyty: każdy pokój minuta po minucie, pobyty tworzone przeciągnięciem i automatycznie rezerwowane sprzątanie pomiędzy nimi.",
    point1: "Status każdego pokoju w czasie rzeczywistym",
    point2: "Przeciągnij, aby utworzyć, przenieść lub przedłużyć pobyt",
    point3: "Automatyczne sprzątanie między pobytami",
    cta: "Włącz rezerwację godzinową",
    ctaBlocked: "Aby włączyć, należy spełnić wymagania",
    noHotelsTitle: "Brak hotelu",
    noHotels: "Rezerwacja godzinowa działa w obiektach typu hotel, w których utworzono pokoje.",
  },
  guide: {
    open: "Jak to działa",
    title: "Jak działa kalendarz godzinowy",
    subtitle: "Najważniejsze w minutę: tworzenie pobytów, meldowanie i wymeldowywanie gości oraz zamykanie pokoi, które nie są sprzedawane.",
    createTitle: "Utwórz pobyt",
    createBody: "Przeciągnij wzdłuż wiersza pokoju, od godziny check-in do godziny check-out. Można też kliknąć „Nowy pobyt” i wpisać godziny ręcznie.",
    moveTitle: "Przenoszenie i przedłużanie",
    moveBody: "Przeciągnij pasek, aby zmienić jego godzinę lub pokój. Pociągnij prawą krawędź, aby wydłużyć lub skrócić pobyt. Jeśli termin jest zajęty, kalendarz nie pozwoli go upuścić.",
    checkinTitle: "Check-in i check-out",
    checkinBody: "Otwórz pobyt i zamelduj gościa po przyjeździe, a wymelduj przy wyjściu. Przy przekroczeniu czasu pasek zmienia się na czerwony i pokazuje dodatkowe minuty.",
    cleaningTitle: "Sprzątanie między pobytami",
    cleaningBody: "Po każdym check-out kalendarz rezerwuje ustawiony czas sprzątania. W tym oknie nikt nie może się zameldować.",
    blockTitle: "Zablokuj przedział lub zamknij pokój",
    blockBody: "Zaznacz zakres i wybierz „Zablokuj ten przedział” albo „Zamknij pokój na cały dzień”, jeśli tego dnia nie jest sprzedawany. Kliknięcie blokady pozwala zmienić jej powód lub ją usunąć.",
    settingsTitle: "Ustawienia",
    settingsBody: "W ustawieniach można określić czas sprzątania, godzinę rozpoczęcia doby kalendarzowej oraz szybkie czasy trwania widoczne przy tworzeniu pobytu.",
    colorsTitle: "Co oznacza każdy kolor",
    colors: {
      booked: "Utworzony, gość jeszcze się nie zameldował",
      inHouse: "Gość jest w pokoju",
      overdue: "Po godzinie check-out",
      cleaning: "Czas zarezerwowany na sprzątanie",
      night: "Pochodzi z kalendarza nocnego",
      closed: "Zablokowany lub zamknięty ręcznie",
    },
    otasTitle: "Rezerwacje nocne i kanały",
    otasBody: "Rezerwacje nocne są tu widoczne, aby wiadomo było, które pokoje są zajęte, ale zarządza się nimi w kalendarzu hotelu. W czasie sprzedaży na godziny ten obiekt nie łączy się z OTA.",
    gotIt: "Rozumiem",
  },
  toasts: {
    created: "Pobyt został utworzony",
    checkedIn: "Check-in został zapisany",
    checkedOut: "Check-out zapisany · sprzątanie rozpoczęte",
    updated: "Zmiany zostały zapisane",
    extended: "Pobyt został przedłużony",
    cancelled: "Pobyt został anulowany",
    noShow: "Oznaczono jako niestawienie się",
    moved: "Pobyt został przeniesiony",
    resized: "Czas trwania został zaktualizowany",
    activated: "Rezerwacja godzinowa została włączona",
    blocked: "Przedział został zablokowany",
    blockUpdated: "Powód został zaktualizowany",
    blockRemoved: "Blokada została usunięta",
    loadError: "Nie udało się wczytać kalendarza godzinowego",
    error: "Nie udało się zapisać. Proszę spróbować ponownie.",
  },
  errors: {
    room_busy: "Pokój jest zajęty od {from} do {to}",
    hourly_disabled: "Rezerwacja godzinowa nie jest włączona w tym hotelu.",
    room_maintenance: "Ten pokój jest wyłączony z użytku.",
    room_not_found: "Ten pokój nie należy do tego hotelu.",
    invalid_duration: "Czas trwania musi wynosić od 30 minut do 48 godzin.",
    invalid_start: "Godzina check-in jest nieprawidłowa.",
    stay_closed: "Ten pobyt jest już zamknięty i nie można go przenieść.",
    invalid_status: "Ta akcja nie jest dostępna dla bieżącego statusu pobytu.",
    requirements_not_met: "Ten hotel nie spełnia jeszcze wymagań rezerwacji godzinowej.",
    not_found: "Nie udało się tego znaleźć. Proszę odświeżyć stronę.",
    generic: "Coś poszło nie tak. Proszę spróbować ponownie.",
  },
};
